import { META_CONFIGS } from "@/constants/MetaTags";

export default META_CONFIGS.home.title;
